<!-- components/PointChargePopup.svelte -->
<script>
  import { addPoint } from '@lib/api/point';
  export let user = {};            // { _id, kakao_id, nickname, point, ... }
  export let onClose = () => {};     // 팝업 닫기 콜백
  export let onSave = () => {};      // 저장 완료 콜백

  let warningMessage = '';           // 경고/에러 메시지
  let successMessage = '';           // 성공 안내
  let loading = false;

  let formData = {
    amount: '',
    reason: '관리자 수동 충전',
  };

  async function handleSubmit() {
    warningMessage = '';
    successMessage = '';

    const amountNum = Number(formData.amount);
    if (!user || !user._id) {
      warningMessage = '대상 사용자가 없습니다.';
      return;
    }
    if (!Number.isFinite(amountNum) || amountNum <= 0) {
      warningMessage = '충전 금액은 1 이상 숫자여야 합니다.';
      return;
    }

    try {
      loading = true;
      const param = {
        user_id: user._id,
        amount: amountNum,
        reason: formData.reason
      };
      console.log(param)
      await addPoint(param);
      successMessage = '충전이 완료되었습니다.';
      // 부모에게 완료 알림 (리스트 새로고침 등)
      onSave();
      // 잠시 표시 후 닫기
      setTimeout(() => onClose(), 500);
    } catch (e) {
      warningMessage = e?.message || '충전 중 오류가 발생했습니다.';
    } finally {
      loading = false;
    }
  }
</script>

<div class="popup-wrap">
  <div class="popup-overlay" role="presentation" aria-label="팝업 닫기" on:click={onClose}></div>
  <section class="popup-container">
    <div class="popup-container__inner d-flex" style="max-width:44rem;">
      <div class="d-flex flex-column w-100">
        <div class="popup-header">
          <div class="d-flex align-center w-100">
            <p class="font-20 font-weight-700 line-height-2">포인트 충전</p>
            <button type="button" class="btn-close ml-auto" aria-label="닫기" on:click={onClose}>
              <i class="icon icon-close"></i>
            </button>
          </div>
        </div>

        <div class="popup-cont">
          <div class="d-flex h-100">
            <div class="prompt-block w-100">
              <div class="table-wrap flex-1">
                <table class="table-basic table-border">
                  <colgroup><col style="width:28%"><col style="width:auto"></colgroup>
                  <tbody>
                    <tr>
                      <th scope="row">사용자</th>
                      <td>
                        {#if user}
                          <div class="d-flex align-center gap-2">
                            <span class="font-weight-700">{user.nickname}</span>
                            <small class="color-gray">({user.kakao_id})</small>
                          </div>
                        {/if}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">현재 포인트</th>
                      <td>{user?.point ?? 0}</td>
                    </tr>
                    <tr>
                      <th scope="row">충전 금액</th>
                      <td>
                        <form action="" class="d-flex align-center gap-8">
                          <fieldset class="w-100">
                            <legend>충전 금액 입력</legend>
                            <label for="input-field-point-amount">
                              <input
                                id="input-field-point-amount"
                                type="number"
                                min="1"
                                class="input-field height-40"
                                placeholder="예: 100"
                                bind:value={formData.amount}
                                on:keydown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); } }}
                              >
                            </label>
                          </fieldset>
                        </form>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">사유</th>
                      <td>
                        <form action="">
                          <fieldset class="w-100">
                            <legend>충전 사유</legend>
                            <label for="input-field-point-reason">
                              <input
                                id="input-field-point-reason"
                                type="text"
                                class="input-field height-40"
                                placeholder="관리자 수동 충전"
                                bind:value={formData.reason}
                              >
                            </label>
                          </fieldset>
                        </form>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {#if warningMessage}
                <p class="d-flex align-center mt-3 font-13 color-red">
                  <i class="icon icon-calmMark-red mr-1"></i>{warningMessage}
                </p>
              {/if}
              {#if successMessage}
                <p class="d-flex align-center mt-3 font-13" style="color:#0a0;">
                  <i class="icon icon-check mr-1"></i>{successMessage}
                </p>
              {/if}
            </div>
          </div>
        </div>

        <div class="popup-footer">
          <div class="btn-wrap justify-center" style="border-top:none;">
            <button type="button" class="btn border-blue" on:click={onClose} disabled={loading}>취소</button>
            <button type="button" class="btn bg-blue ml-2" on:click={handleSubmit} disabled={loading}>
              {loading ? '처리 중...' : '충전하기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
